module.exports = __webpack_public_path__ + "img/part3.784ecdcb.png";